var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
export var ThirdNumberImage = function () {
    return (_jsx("svg", __assign({ width: "82", height: "107", viewBox: "0 0 82 107", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, { children: _jsx("path", { d: "M39.6 106.5C32.2 106.5 24.95 105.45 17.85 103.35C10.85 101.15 4.95 98.15 0.15 94.35L8.55 79.2C12.35 82.3 16.95 84.8 22.35 86.7C27.75 88.6 33.4 89.55 39.3 89.55C46.3 89.55 51.75 88.15 55.65 85.35C59.55 82.45 61.5 78.55 61.5 73.65C61.5 68.85 59.7 65.05 56.1 62.25C52.5 59.45 46.7 58.05 38.7 58.05H29.1V44.7L59.1 8.99999L61.65 16.35H5.25V-7.15256e-06H76.8V13.05L46.8 48.75L36.6 42.75H42.45C55.35 42.75 65 45.65 71.4 51.45C77.9 57.15 81.15 64.5 81.15 73.5C81.15 79.4 79.65 84.85 76.65 89.85C73.65 94.85 69.05 98.9 62.85 102C56.75 105 49 106.5 39.6 106.5Z", fill: "#CDCDCD", fillOpacity: "0.26" }) })));
};
